import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFModalOpenSvgH5, EFModalCloseBlackSvgH5 } from '@/components/UI/svg/mm100';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/modals/');
const { EFPic: EFPicPc } = createEFPic('/media/mm100/pc/modals/');

export default function CablePack() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [modalVisible, setModalVisible] = useState(false);
    const { locale } = useRouter();

    const imgLocale = getImageLocal(locale, ['au', 'cn']);

    const circleList = [
        { bgColor: '#1dc132', left: '0' },
        { bgColor: '#1dc132', left: '0.27rem' },
        { bgColor: '#1dc132', left: '0.26rem' },
        { bgColor: '#1dc132', left: '0.34rem' },
        { bgColor: '#ff813e', left: '0.02rem' },
        { bgColor: '#1dc132', left: '0.43rem' },
        { bgColor: '#ff813e', left: '0.02rem' },
        { bgColor: '#1dc132', left: '0.44rem' },
        { bgColor: '#ff813e', left: '0.02rem' },
        { bgColor: '#1dc132', left: '0.45rem' },
    ];

    const cableList = [
        {
            title: t('presale.product.modals.cable_content1_desc1'),
            supTitle: t('presale.product.modals.cable_spec1'),
            img: ['line1.webp', 'line1.jpg'],
        },
        {
            title: t('presale.product.modals.cable_content1_desc2'),
            supTitle: t('presale.product.modals.cable_spec2'),
            img: ['line2.webp', 'line2.jpg'],
        },
        {
            title: t('presale.product.modals.cable_content1_desc4'),
            supTitle: t('presale.product.modals.cable_spec3'),
            img: ['line3.webp', 'line3.jpg'],
        },
        {
            title: t('presale.product.modals.cable_content2_desc1'),
            supTitle: t('presale.product.modals.cable_spec4'),
            img: ['line4.webp', 'line4.jpg'],
        },
        {
            title: t('presale.product.modals.cable_content2_desc2'),
            supTitle: t('presale.product.modals.cable_spec5'),
            img: ['line5.webp', 'line5.jpg'],
        },
    ];

    const changeModal = (visible: boolean) => setModalVisible(visible);

    return (
        <div className={`${css.CablePack} CablePack`}>
            <div className="text-title-a1">{t('presale.product.modals.cable_title')}</div>
            <div className="text-title-a2">{t('presale.product.modals.cable_learn')}</div>
            <div className="cable-type">
                <div className="circle-common"></div>
                <div className="circle-dec">{t('presale.product.modals.cable_input')}</div>
                <div className="circle-common circle-red"></div>
                <div className="circle-dec">{t('presale.product.modals.cable_output')}</div>
            </div>
            <div className="img-content1">
                <div className="img-content1-in">
                    <EFPic name={[`CablePack1_${imgLocale}.webp`, `CablePack1_${imgLocale}.png`]} className="fullImgs" alt="" />
                </div>
                <div className="circle-box">
                    {circleList.map((item, index) => (
                        <div key={index} className="circle-item" style={{ backgroundColor: item.bgColor, marginLeft: item.left }}></div>
                    ))}
                </div>
                <div className="cable-desc cable-content1-desc1">{t('presale.product.modals.cable_content1_desc1')}</div>
                <div className="cable-desc cable-content1-desc2">{t('presale.product.modals.cable_content1_desc2')}</div>
                <div className="cable-desc cable-content1-desc3">{t('presale.product.modals.cable_content1_desc3')}</div>
                <div className="cable-desc cable-content1-desc4">
                    {['us'].includes(locale) ? t('presale.product.modals.cable_content1_desc4_new') : t('presale.product.modals.cable_content1_desc4')}
                </div>
            </div>
            <div className="img-content2">
                <EFPic name={[`CablePack2_${imgLocale}.webp`, `CablePack2_${imgLocale}.png`]} className="fullImgs" alt="" />
                <div className="b-title">{t('presale.product.modals.cable_content2_title2')}</div>
                <div className="b-title b1-title">{t('presale.product.modals.cable_content2_title1')}</div>
                <div className="circle circle-1"></div>
                <div className="circle circle-2"></div>
                <div className="cable-desc cable-content2-desc1">{t('presale.product.modals.cable_content2_desc1')}</div>
                <div className="cable-desc cable-content2-desc2">{t('presale.product.modals.cable_content2_desc2')}</div>
                <div className="circle3-line" style={{ display: locale === 'us' ? 'block' : 'none' }}></div>
                <div className="circle circle-3" style={{ display: locale === 'us' ? 'block' : 'none' }}></div>
                <div className="cable-content2-desc3" style={{ display: locale === 'us' ? 'block' : 'none' }}>
                    {t.rich('presale.product.modals.cable_line_text', {
                        line1: (child: any) => <span className="text"> {child}</span>,
                    })}
                </div>
            </div>
            <div className="text2-content">
                <div
                    className="default-content"
                    style={{
                        display: !modalVisible ? 'block' : 'none',
                        paddingBottom: ['us'].includes(locale) ? '0.14rem' : '0.52rem',
                    }}
                >
                    <div className="text-title-b1">{t('presale.product.modals.cable_text1')}</div>
                    <div className="text-title-b2">{t(locale === 'kr' ? 'presale.product.modals.cable_text2_h5' : 'presale.product.modals.cable_text2')}</div>
                    <div className="open-modal" style={{ display: ['us'].includes(locale) ? 'block' : 'none' }}>
                        <EFModalOpenSvgH5 width="0.22rem" height="0.22rem" onClick={() => changeModal(true)} />
                    </div>
                </div>
                <div className="open-content" style={{ display: modalVisible ? 'block' : 'none' }}>
                    {cableList.map((item, index) => (
                        <div className="content-item" key={index}>
                            <div className="left-item">
                                <EFPicPc name={item.img} className="fullImgs" alt="" />
                            </div>
                            <div className="right-item">
                                <div className="v-msg1">{item.title}</div>
                                <div className="v-msg2">{item.supTitle}</div>
                            </div>
                        </div>
                    ))}
                    <div className="close-modal">
                        <EFModalCloseBlackSvgH5 width="0.31rem" height="0.31rem" onClick={() => changeModal(false)} />
                    </div>
                </div>
            </div>
        </div>
    );
}
